import { createBrowserRouter } from 'react-router-dom'

import { MarketingLayout } from '@/layouts/MarketingLayout'
import { AssetsPage } from '@/pages/Assets/AssetsPage'
import { HomePage } from '@/pages/Home/HomePage'
import { LoginPage } from '@/pages/Login/LoginPage'
import { NotFoundPage } from '@/pages/NotFound/NotFoundPage'
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicy/PrivacyPolicyPage'
import { SupportPage } from '@/pages/Support/SupportPage'
import { TermsOfServicePage } from '@/pages/TermsOfService/TermsOfServicePage'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MarketingLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'support', element: <SupportPage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'terms-of-service', element: <TermsOfServicePage /> },
      { path: 'login', element: <LoginPage /> },
      { path: 'assets', element: <AssetsPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
])
